import { ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { authInterceptor, errorInterceptor } from '@core/interceptors';
import { AuthGuard } from '@core/guards';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(withInterceptors([errorInterceptor, authInterceptor])),
        importProvidersFrom(BrowserAnimationsModule),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        AuthGuard,
    ],
};